import { Box, Typography, styled } from '@mui/material';

export const StyledWidgetGlobalChromecast = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
  position: 'relative',
  height: '100%',
  width: '20%'
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  fontSize: '48px',
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.content.tertiary,
  fontWeight: 400,
  fontSize: '16px'
}));

export const NumberContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'end',
  lineHeight: '34px',
  justifyContent: 'start',
}));

export const Number = styled(Typography)(({ theme }) => ({
  color: theme.palette.content.primary,
  fontWeight: 600,
  fontSize: '24px'
}));

export const UsageRateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  gap: 4,
  marginTop: theme.spacing(2),
  fontSize: '12px',
}));

export const UsageRateLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.content.tertiary,
  fontWeight: 400,
  fontSize: '12px',
}));

export const UsageRateValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.content.primary,
  fontWeight: 500,
  fontSize: '12px',
}));
